import { render } from "./PolicyHolder.vue?vue&type=template&id=2242d48d&scoped=true"
import script from "./PolicyHolder.vue?vue&type=script&lang=js"
export * from "./PolicyHolder.vue?vue&type=script&lang=js"

import "./PolicyHolder.vue?vue&type=style&index=0&id=2242d48d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2242d48d"]])

export default __exports__